import { render, staticRenderFns } from "./storeLayoutMethod.vue?vue&type=template&id=2d21ac8d&scoped=true&"
import script from "./storeLayoutMethod.vue?vue&type=script&lang=js&"
export * from "./storeLayoutMethod.vue?vue&type=script&lang=js&"
import style0 from "./storeLayoutMethod.vue?vue&type=style&index=0&id=2d21ac8d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21ac8d",
  null
  
)

export default component.exports